import styled from 'styled-components';
import {
  brightBlue, red, lightGrey, teko,
} from '../../../utils/theme';
import { mobile, tablet } from '../../../utils/breakpoints';

export const Container = styled.div`
  line-height: 30px;
  font-size: 22px;
  background: #fff;
  padding: 70px;
  position: relative;
  margin: 0px auto;
  max-width: 1200px;

  @media (max-width: ${tablet.max}px) {
    padding: 30px 0;
  }

  .articles-wrapper {
    margin-left: 37px;
    margin-right: 37px;

    @media (max-width: ${tablet.max}px) {
      margin-left: 60px;
      margin-right: 60px;
    }

    &.with-featured {
      margin-top: 55px;
    }
  }

  .slick-dots li button:before {
    background: ${brightBlue};
  }

  .slick-dots li.slick-active button:before {
    background: ${red};
  }

  .slick-next {
    right: -38px;
  }

  .slick-prev {
    left: -36px;
  }

  .more-link {
    display: block;
    ${teko} font-size: 18px;
    color: ${brightBlue};
    letter-spacing: 1.43px;
    line-height: 40.8px;
    text-align: right;
    border-top: 1px solid ${lightGrey};
    margin: 0 -30px;
    padding: 10px 30px 0;

    img {
      padding-left: 4px;
    }

    @media (max-width: ${mobile.max}px) {
      padding: 20px 30px 0;
      margin: 0;
      img {
        display: inline-block;
      }
    }
  }

  @media(max-width: ${mobile.max}px) {
    h1 {
      padding: 0 30px 18px 30px;
    }
  }
`;

export const Wrapper = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  .slick-list {
    width: 100%;
  }
`;



// WEBPACK FOOTER //
// ./src/components/news/styles/news.style.js